import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {fetchNotificationsList, fetchNotificationsUnreadAmount} from "../services/notifications";


export const useNotificationsQuery = () => {
    const limit = 5;
    return useInfiniteQuery({
        queryKey: ['notifications'],
        queryFn: ({pageParam = {limit: limit, offset: 0}}) => fetchNotificationsList(pageParam.limit, pageParam.offset),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}

export const useNotificationsUnreadQuery = () => {
    return useQuery({
        queryKey: ['unreadNotifications'],
        queryFn: () => fetchNotificationsUnreadAmount(),
    })
}